import { render } from "./Licenses.vue?vue&type=template&id=06cbd179&scoped=true"
import script from "./Licenses.vue?vue&type=script&lang=js"
export * from "./Licenses.vue?vue&type=script&lang=js"

import "./Licenses.vue?vue&type=style&index=0&id=06cbd179&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06cbd179"]])

export default __exports__